import React, {useState} from "react";
import TimelineSubmitStruct from "../students/components/timeline/TimelineSubmitStruct";
import Select from "react-select";

export function StudentForceSubmit(props) {

    const [optionSession,setOptionSession] = useState(sessionOptions()[0].value);
    function sessionOptions() {
        const result = props.case.sessions.map(obj => ({
            value: obj.id,
            label: obj.sessionIndex
        }));
        console.log(result)
        return result;
    }

    return(
        <div>
            <Select class="mb-3" onChange={(e) => setOptionSession(e.value)} defaultValue={sessionOptions()[0]}  options={sessionOptions()}/>
            <TimelineSubmitStruct data={{caseId: props.case.id,session:optionSession,studentNumber: props.student, callback: ()=>{alert("klaar")}}}/>
        </div>
    );
}